const MAX = 8;

export function createHistory() {
  /** @type {Array<{ type: string, text: string, year?: number, t: number }>} */
  const items = [];

  return {
    push(event) {
      if (!event) return;
      const text = formatEvent(event);
      items.unshift({
        type: event.type,
        text,
        year: event.year,
        t: Date.now(),
      });
      if (items.length > MAX) items.length = MAX;
    },
    list() {
      return items.slice();
    },
    clear() {
      items.length = 0;
    },
  };
}

function formatEvent(ev) {
  if (ev.type === 'destroy') {
    if (ev.cause === 'freezing') {
      return `第 ${ev.civId} 号文明在极寒中沉睡` + yearSuffix(ev.year);
    }
    return `第 ${ev.civId} 号文明在三日炙烤中毁灭` + yearSuffix(ev.year);
  }
  if (ev.type === 'rebirth') {
    return `第 ${ev.civId} 号文明自废墟中醒来` + yearSuffix(ev.year);
  }
  if (ev.type === 'reset') {
    return '观察者重置星系';
  }
  return ev.text || ev.type;
}

function yearSuffix(year) {
  return year != null ? ` · Year ${year}` : '';
}
